module.exports = __webpack_public_path__ + "static/media/be-the-hero.5e266390.png";